import { useMutation } from '@tanstack/react-query';
import { modemApis } from '../../../../../../shared/apis/modem/apis';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import { handleError } from '../../../../../ui/err/handleError';

export default function usePutModem() {
  return useMutation(modemApis.putModem, {
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
